/* stylelint-disable-next-line selector-class-pattern */
.faq_wrapper {
  margin: 0 auto;
  max-width: 1216px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &_title {
    text-align: center;
    padding: $space-03 0;

    &_text {
      font-size: 32px !important;
      font-weight: 600;
    }
  }

  &_title2 {
    padding-bottom: $space-02;

    &_text {
      font-size: 32px !important;
      font-weight: 600;
      line-height: 40px;
    }
  }
}
